var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMiddleLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  fillRule: "evenodd",
  d: "M4.063 20.769V2.864a.832.832 0 0 0-1.664 0v17.905a.832.832 0 0 0 1.664 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  d: "M9.393 12.603H19.96a.9.9 0 0 0 0-1.8H9.393v-2.7l-3.591 3.6 3.591 3.6z"
})));
export default SvgMiddleLeft;